"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const SeguridadAbiertaIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== 'auto') {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "-10 -10 720 720" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M572.4 322.9c.1-1.9 1.5-25.8-13.6-42.1-10.7-11.6-28-17.4-51.3-17.4-90.5 0-301 .3-311.9.3h-1c-.5 0-1.1 0-1.6-.1-.1 0-1.2-.1-2.9-.1-7.8 0-29.6 1.3-44.2 15-10.2 9.6-15.4 24.5-15.4 44.2v277.9c-.1 1.6-1.2 25.7 14.1 42.1 10.6 11.4 27.5 17.2 50.3 17.2l312.7-.2c1.7 0 31.4 1.7 49.6-15.7 10.3-9.9 15.3-24.3 15.3-44-.2-91.4-.1-277.1-.1-277.1zm42.4 1.8c.1 0 0 184.3.1 275.2 0 32-9.7 57.4-29 75.6-31.9 30.2-78 27.2-79.9 27.1l-311.2.2c-35.2 0-62.7-10.5-81.7-31.2-27.8-30.3-25.2-71-25.1-72.7l-.1-276.3c0-32.3 9.9-57.9 29.3-76 18.1-16.9 40.7-23 57.1-25.1V179C174.3 48.2 261.4.8 342.9 0c5.2 0 10.7.1 15.5.1C424 1.7 501.7 35.7 522.7 126.4c2.7 11.6-4.4 23.2-15.8 25.9-11.3 2.7-22.8-4.4-25.6-16-19.5-84.2-99.8-92.6-124-93.2-4.3-.1-9.4-.1-14.1-.1-38 .3-126.5 14.3-126.5 135.9v41.6c58-.1 215.6-.3 290.6-.3 35.9 0 63.8 10.6 82.9 31.6 27.7 30.5 24.7 71 24.6 72.9zM350 509.2c48.4-.9 48.4-38.4 48.4-52.5 0-12.8 0-51.8-49.1-53-1.9 0-4-.1-6-.1h-1.5c-47.5.5-47.5 38.3-47.5 52.5 0 14.3 0 52.5 48.4 53.1h7.3zm.3-148.5c18.5.5 90.6 7.9 90.6 96 0 88.4-72.2 95.2-90.3 95.6h-8.7c-19-.3-90.3-7.2-90.3-96.2 0-88.7 70.6-95.4 89.6-95.5h1.9c2.5 0 5 0 7.2.1z" }))));
};
exports.default = SeguridadAbiertaIconM;
//# sourceMappingURL=index.js.map